import React, { useState, useCallback, useEffect } from 'react'
import { Line } from 'react-chartjs-2'
import moment from 'moment/moment'
import { useDispatch, useSelector } from 'react-redux'
import API from '@/util/api'
import { getStartDate, getEndDate, isSearching, setSearching } from '@/store/statisticsSlice'

const StatLogin = () => {
  const [data, setData] = useState({ labels: '', datasets: [] })
  const dispatch = useDispatch()
  const isSearch = useSelector(isSearching)
  const startDate = useSelector(getStartDate)
  const endDate = useSelector(getEndDate)

  const onSearch = useCallback(async () => {
    const res = await API.get('/api/log/logins', {
      params: {
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD')
      }
    }).catch(() => {
      return {
        data: []
      }
    })
    const datasets = {
      labels: res.data.map(m => { return m.str }),
      datasets: [
        {
          data: res.data.map(m => { return m.count })
        },
      ]
    }
    setData(datasets)
    dispatch(setSearching(false))
  }, [dispatch, endDate, startDate])

  useEffect( () => {
    if (isSearch === true) {
      onSearch()
    }
  }, [isSearch, onSearch])

  return (
    <>
      <div className="ui attached message flex-item">
        <div className="header">접속자 통계</div>
        <span className="h_subTitle flex-left-auto">{`범위 : ${moment(startDate).format('YYYY-MM-DD')} ~ ${moment(endDate).format('YYYY-MM-DD')}`}</span>
      </div>
      <div className="ui bottom attached segment">
        <div className="chart-box">
          <div className="chart-container">
            <div style={{ width: '100%', height: '400px' }}>
              <Line data={data} options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  y: {
                    afterDataLimits: (axis) => {
                      axis.max += 10
                    }
                  }
                },
                plugins: {
                  datalabels: {
                    color: '#36A2EB',
                    align: 'end',
                    anchor: 'end',
                  },
                  legend: {
                    display: false
                  }
                }
              }} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StatLogin
